<template>
  <div class="cpt-user-avatar" :class="`${size} ${shape}`">
    <div class="avatar-img-background" :class="{'default-bg': show_bg}">
      <img
        class="avatar-img"
        v-if="no_lazy"
        :src="img + `?imageMogr2/format/png/quality/30/ignore-error/1/thumbnail/${thumbnail}x/`"
        alt=""
      >
      <ChatImg 
        v-else
        class="avatar-img" 
        :src="img" 
        :webp_quality="30"
        :gif_active_type="gif_active_type"
        :thumbnail="`${thumbnail}x`"
        :hover_dom_handler="hover_dom_handler || (() => $el)"
      />
      <ChatImg
        v-if="user_account_settings.show_decoration && avatar_decoration && avatar_decoration.src_url"
        class="avatar-decoration"
        :src="avatar_decoration.src_url"
        :lazy="!no_lazy"
        :animation="!no_lazy"
        :gif_active_type="gif_active_type"
        :hover_dom_handler="hover_dom_handler || (() => $el)"
      />
    </div>
    <div 
      class="right-mobile" 
      v-if="!hideOnline && onlineState == 2" 
      :class="{on: onlineState}"
      :style="{
        background: borderColor,
      }"
    >
      <i class="iconfont icon-mobile"></i>
    </div>
    <div 
      class="right-circle" 
      v-else-if="!hideOnline && onlineState < 2" 
      :class="{on: onlineState}" 
      :style="{
        'border-width': (size=='big' ? '3px' : '2px'),
        'border-color': borderColor
      }"
    ></div>
    <div 
      class="right-circle other-state" 
      v-else-if="onlineState === 5"
      :style="{
        'border-width': (size=='big' ? '3px' : '2px'),
        'border-color': borderColor
      }"
      >
      <i class="iconfont icon-history-nop"></i>
    </div>
    <div 
      class="right-circle other-state"
      v-else-if="onlineState === 6"
      :style="{
        'border-width': (size=='big' ? '3px' : '2px'),
        'border-color': borderColor
      }"
      >
      <i class="iconfont icon-toast-stop-nop" ></i>
    </div>
    <template v-if="unread_count">
      <div
        class="unread-count"
        v-if="!show_unread_dot"
        :style="{
          'border-color': show_theme_data.bar_color ? show_theme_data.bar_color[0] : '',
        }"
      >
        <div class="unread-count-text">{{ unread_count > 99 ? '99+' : unread_count }}</div>
      </div>
      <div class="unread-red-dot" v-else></div>
    </template>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  props: {
    avatar_decoration: {
      type: Object,
      default: () => {}
    },
    img: {
      default: '',
      type: String
    },
    onlineState: {
      default: false,
      type: [Boolean, Number],
    },
    hideOnline: {
      default: false,
    },
    unread_count: {
      default: '',
    },
    size: {
      default: 'small'
    },
    shape: {
      default: '',
      type: String,
    },
    no_lazy: {
      default: false,
    },
    borderColor: {
      default: '',
      type: [String, Number],
    },
    show_bg: {
      type: Boolean,
      default: false,
    },
    gif_active_type: {
      default: 'hover',
      type: String,
    },
    width: {
      default: 0,
      type: Number,
    },
    hover_dom_handler: {
      default: null,
    },
    show_unread_dot: {
      default: false,
      type: Boolean,
    },
  },
  computed: {
    thumbnail () {
      let width = this.width
      if (!width) {
        width = this.size == 'big' ? 50 : 32
      }
      return width * 3
    },
    ...mapGetters(["user_account_settings", "show_theme_data"]),
  },
};
</script>

<style lang="scss">
.cpt-user-avatar {
  width: 32px;
  height: 32px;
  position: relative;
  &.big {
    width: 50px;
    height: 50px;
    .right-circle {
      width: 16px;
      height: 16px;
      right: 0;
      bottom: 0;
      border: solid $d-fl-2;
      z-index: 1;
    }
    .right-mobile {
      width: 14px;
      height: 18px;
      right: -3px;
      bottom: -3px;
      i {
        padding: 3px 1px;
      }
    }
  }
  &.rectangle {
    .avatar-img-background {
      border-radius: 8px;
      .avatar-img {
        border-radius: 8px;
      }
    }
  }
  .avatar-img-background {
    position: relative;
    width: 100%;
    height: 100%;
    object-fit: cover;
    background-color: $d-op-1;
    border-radius: 50%;
    &.default-bg {
      background-color: $d-fl-3;
    }
    .avatar-img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      border-radius: 50%;
    }
    .avatar-decoration {
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      width: 140%;
      height: 140%;
      pointer-events: none;
      z-index: 1;
      object-fit: cover;
      border-radius: initial;
      img {
        pointer-events: none ;
      }
    }
  }
  .right-circle {
    width: 12px;
    height: 12px;
    position: absolute;
    right: -2px;
    bottom: -2px;
    background-color: $d-tx-3;
    border-radius: 50%;
    border: solid $d-fl-1;
    z-index: 1;
    &.on {
      background-color: $d-ss-tx;
    }
    &.other-state {
      background-color: $d-fl-1;
      border: solid $d-fl-1;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
  .right-mobile {
    width: 12px;
    height: 16px;
    position: absolute;
    right: -2px;
    bottom: -2px;
    color: $d-fl-nv;
    border-radius: 2px;
    background: $d-fl-1;
    z-index: 1;
    &.on {
      color: $d-ss-tx;
    }
    i {
      width: 12px;
      height: 12px;
      font-size: 12px;
      padding: 2px 0;
      display: block;
    }
  }
  .icon-history-nop {
    width: 14px;
    height: 14px;
    font-size: 14px;
    color: $d-wn-tx;
  }
  .icon-toast-stop-nop {
    width: 14px;
    height: 14px;
    font-size: 14px;
    color: $d-er-tx;
  }

  .unread-count {
    position: absolute;
    right: -10px;
    top: -4px;
    height: 36px;
    min-width: 36px;
    padding: 0 4px;
    border: 4px solid $d-fl-1;
    background: $d-er-fl;
    border-radius: 18px;
    transform: scale(.5);
    transform-origin: right top;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1;
    &-text {
      font-size: 22px;
      font-weight: 500;
      color: $ct-wh-0;
      text-align: center;
      font-family: 'Roboto';
    }
  }
  .unread-red-dot {
    position: absolute;
    right: -2px;
    top: -2px;
    width: 12px;
    height: 12px;
    border-radius: 50%;
    border: 2px var(--show-theme-color) solid;
    background: $d-er-fl;
  }

  &.small {

    .icon-history-nop {
      font-size: 12px;
      transform: scale(0.6667);
      color: $d-wn-tx;
      margin-top: 1px;
    }
    .icon-toast-stop-nop {
      font-size: 12px;
      transform: scale(0.6667);
      color: $d-er-tx;
      margin-top: 1px;
    }
  }
}
</style>
